import { useSelector } from "react-redux";
import { USER_ROLES } from "static/constants";
import { filterNonUCHAccounts } from "utils/account.util";

const useCheckRPMSaaSAccountUser = () => {
  const { accounts } = useSelector((state) => state.account);
  const { currentUser } = useSelector((state) => state.auth);

  const filteredAccounts = filterNonUCHAccounts(accounts);
  const isRpmOnlyAccount = filteredAccounts?.every(
    (account) => account?.rpm_only
  );

  const isRPMSaaSUser =
    isRpmOnlyAccount && currentUser?.role === USER_ROLES.RPM_USER;

  return isRPMSaaSUser;
};

export default useCheckRPMSaaSAccountUser;
